import React from 'react'
import { Redirect, Route } from 'react-router-dom'
import withAuth from '../hoc/withAuth'
import Layout from './ui/layout/layout/Layout'
import { MobileBackProvider } from '../context/MobileBackContext'

const PrivateRoute = ({ auth, component: Component, ...rest }) => {
  if (!Object.keys(auth).length) {
    return <Redirect to="/" />
  }

  return (
    <Route
      {...rest}
      render={props => (
        <MobileBackProvider>
          <Layout>
            <Component {...props} />
          </Layout>
        </MobileBackProvider>
      )}
    />
  )
}

export default withAuth(PrivateRoute)
